import React from 'react';
const PlusIcon = (props) => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "#005A5A", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { id: "plus" },
        React.createElement("path", { id: "Vector", d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" }))));
export default PlusIcon;
